/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Manual_Qc_NoInputs */

const en_manual_qc_no = /** @type {(inputs: Manual_Qc_NoInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`No`)
};

const fr_manual_qc_no = /** @type {(inputs: Manual_Qc_NoInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Non`)
};

const de_manual_qc_no = /** @type {(inputs: Manual_Qc_NoInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`NEIN`)
};

const it_manual_qc_no = /** @type {(inputs: Manual_Qc_NoInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`NO`)
};

const ru_manual_qc_no = /** @type {(inputs: Manual_Qc_NoInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Нет`)
};

const es_manual_qc_no = /** @type {(inputs: Manual_Qc_NoInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`No`)
};

const zh_cn2_manual_qc_no = /** @type {(inputs: Manual_Qc_NoInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`不`)
};

const ja_manual_qc_no = /** @type {(inputs: Manual_Qc_NoInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`いいえ`)
};

const hi_manual_qc_no = /** @type {(inputs: Manual_Qc_NoInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`नहीं`)
};

const pt_pt2_manual_qc_no = /** @type {(inputs: Manual_Qc_NoInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Não`)
};

/**
* | output |
* | --- |
* | "No" |
*
* @param {Manual_Qc_NoInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const manual_qc_no = /** @type {((inputs?: Manual_Qc_NoInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Manual_Qc_NoInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_manual_qc_no(inputs)
	if (locale === "de") return de_manual_qc_no(inputs)
	if (locale === "it") return it_manual_qc_no(inputs)
	if (locale === "ru") return ru_manual_qc_no(inputs)
	if (locale === "es") return es_manual_qc_no(inputs)
	if (locale === "zh-CN") return zh_cn2_manual_qc_no(inputs)
	if (locale === "ja") return ja_manual_qc_no(inputs)
	if (locale === "hi") return hi_manual_qc_no(inputs)
	if (locale === "pt-PT") return pt_pt2_manual_qc_no(inputs)
	return en_manual_qc_no(inputs)
});